import { DepthTypes } from 'types/ghostMode';

export const GHOST_MODE_DEFAULT_DEPTH_TYPE = DepthTypes.MD;

export const GHOST_MODE_DEPTH_TYPE_LOCAL_STORAGE_KEY = 'ghostModeDepthTypes';
export const GHOST_MODE_PRE_SELECTED_WELLS_KEY = 'ghostModePreSelectedWells';
export const GHOST_MODE_SELECTED_WELLS_KEY = 'ghostModeSelectedWells';
